
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { TopicEvents, TopicModel } from '@/models/topic.model';
import ChallengeTopicMessage from './ChallengeTopicMessage.vue';
import ChallengeTopicMessageForm from './ChallengeTopicMessageForm.vue';
import {
  authModule,
  forumRepliesModule,
  forumRepliesState, userModule
} from '@/utils/store-acessor';
import { ReplyModel } from '@/models/reply.model';
import moment from 'moment-timezone';
import { UserModel } from '@/models/user.model';
import ChallengeTopicReport from '@/components/Challenges/tabs/forum/ChallengeTopicReport.vue';

@Component({
  components: {
    ChallengeTopicReport,
    ChallengeTopicMessage,
    ChallengeTopicMessageForm
  }
})
export default class ChallengeForumTopic extends Vue {
  @Prop({ required: true }) topic!: TopicModel;
  @Prop({ required: true }) challengerId!: number;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @forumRepliesModule.Getter('entities') replies!: ReplyModel[];
  @forumRepliesModule.Getter('loading') messageProgress!: boolean;
  @forumRepliesModule.Getter('lastPage') lastPage!: number;
  @forumRepliesModule.Getter('currentPage') currentPage!: number;
  @forumRepliesModule.Getter('loading') loading!: boolean;
  @userModule.Getter('timezone') timezone!: string;

  confirmDenounce: boolean = false;
  page = 1;

  mounted() {
    if (this.topic.id && this.challengerId) {
      forumRepliesState.fetchAll({
        challengeId: this.challengerId,
        topicId: this.topic.id
      });
    }
  }

  openPublicProfile() {
    const blankPage = this.$router.resolve(`/profile/${this.topic?.user?.id}`);
    window.open(blankPage.href, '_blank');
  }

  formatFullName(model: UserModel): string {
    return `${model?.first_name} ${model?.last_name}`;
  }

  formatTimestamp(date: string) {
    return moment(date).tz(this.timezone).format('YYYY/MM/DD, at h:mm');
  }

  @Emit()
  onForumBack(event: TopicEvents): TopicEvents {
    return event;
  }

  @Watch('page', { immediate: true, deep: true })
  onPageChange(value: number) {
    if (this.topic?.id && this.challengerId) {
      if (!this.loading) {
        forumRepliesState.fetchAll({
          challengeId: this.challengerId,
          topicId: this.topic.id,
          page: value
        });
      }
    }
  }
}
